(ns manatee.routing.handlers
  (:require [bidi.bidi :as bidi]
            [cemerick.url :as url]
            clojure.walk
            kee-frame.api
            [kee-frame.core :as kf]
            [lambdaisland.uri :as uri]
            [re-frame.core :as rf]))

(defn assert-route-data [data]
  (when-not (vector? data)
    (throw (ex-info "Bidi route data is a vector consisting of handler and route params as kw args"
                    {:route-data data}))))

(defn url-not-found [routes data]
  (throw (ex-info "Could not find url for the provided data"
                  {:routes routes
                   :data data})))

(defn route-match-not-found [routes url]
  (throw (ex-info "No match for URL in routes"
                  {:url url
                   :routes routes})))

(defrecord BidiBrowserRouter [routes]
  kee-frame.api/Router
  (data->url [_ data]
    (assert-route-data data)
    (let [[handler & args] data
          route-data (if (and (= 1 (count args))
                              (map? (first args)))
                       (first args)
                       (apply hash-map args))
          path (bidi/path-for* routes handler route-data)]
      (or (if-let [query-params (:query-params route-data)]
            (str path "?" (url/map->query query-params))
            path)
          (url-not-found routes data))))
  (url->data [_ url]
    (if-let [match (bidi/match-route routes url)]
      (merge match
             (-> url
                 uri/uri
                 (update :query #(uri/query-string->map % {:keywordize? true}))))
      (route-match-not-found routes url))))

(rf/reg-event-fx
 :navigate-to
 (fn [_ [_ route]]
   {:navigate-to route}))

(rf/reg-event-fx
 :navigate-back
 (fn [_ _]
   #?(:cljs (.back js/history))))

(kf/reg-controller ::index
                   {:params (fn [{:keys [handler]}]
                              (= handler ::index))
                    :start (fn [_ active]
                             (when active
                               [:navigate-to [:manatee.annotation.handlers/annotate]]))})
